@if (isLoading | async) {
  <div class="overlay">
    <p-progressSpinner
      class="spinner"
      strokeWidth="4"
      animationDuration="1s"
    ></p-progressSpinner>
  </div>
}
